import React, { useEffect, useCallback, useState } from "react";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import axios from "axios";
import { toast } from "react-toastify";
import ErrorAlert from "helper/errorAlert";
import { useNavigate } from "react-router-dom";
import { useApiClient } from "context/ApiClientContext";

export default function Company() {
  const [companies, setCompanies] = React.useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate()

  const [selectedCompanyId, setSelectedCompanyId] = React.useState(
    localStorage.getItem("companyId")
  );
  const id = localStorage.getItem("loggedInID");
  const username = localStorage.getItem("loggedInUsername");
  const apiClient = useApiClient();

  const getCompany = useCallback(async () => {
    let newCompanyArray = [];
    try {
      const response = await axios.get(
        `${apiClient}/user/${id}/company`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      const datas = response.data;

      datas.map((data, index) => {
        if (data.isAccessible) {
          newCompanyArray.push({
            id: data.id,
            companyid: data.companyid,
            code: data.code,
            name: data.name,
          });
        }
      });

      setCompanies(newCompanyArray);
    } catch (error) {
      console.error("An error occurred:", error.response);
    }
  }, []);

  useEffect(() => {
    getCompany();
  }, []);

  const handleChange = (event) => {
    setSelectedCompanyId(event.target.value);
    localStorage.setItem("companyId", event.target.value);
    const data = {
      id: id,
      userName: username,
      lastcompany: event.target.value,
    };
    setLastCompany(data);
    // window.location.reload();
  };

  const setLastCompany = async (data) => {
    try {
      setLoading(true);
      const response = await axios.put(
        `${apiClient}/user/${id}/lastcompany`,
        data,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
            Accept: "application/json",
          },
        }
      );

      const datas = response.data;

      toast.success("Fetch new data...", {
        position: "top-right",
      });

      setTimeout(() => {
        window.location.reload();
      }, 2000);
    } catch (error) {
      ErrorAlert(error, navigate)
      console.error("An error occurred:", error.response);
    } finally {
      setLoading(false);
    }
  };

  return (
    <React.Fragment>
      <FormControl
        variant="standard"
        size="small"
        sx={{ borderColor: "primary.main" }}
      >
        <Select
          labelId="demo-select-small-label"
          id="demo-select-small"
          value={selectedCompanyId}
          label="company name"
          onChange={handleChange}
          sx={{
            color: "white", // Customizes the text color
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "primary.main", // Customizes the border color for the Select
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "secondary.main", // Customizes the border color on hover
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "secondary.main", // Customizes the border color when focused
            },
          }}
        >
          {companies.map((company, i) => (
            <MenuItem key={company.id || i} value={company.companyid}>
              {company.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </React.Fragment>
  );
}
